import checkDocument from "../../../utils/checkDocument";
import checkInputs from "../../../utils/checkInputs";

const validations = {
  editCompany: function validationEditCompany(updateCompany) {
    const errors = {};
    if (updateCompany.subscriptionKey.length > 300) {
      errors.subscriptionKey = "No ingrese más de 300 caracteres.";
    }

   
    return errors;
  },
 
};

export default validations;
